"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useActions", {
  enumerable: true,
  get: function () {
    return _useActions.useActions;
  }
});
exports.useInsights = exports.useState = exports.useDispatch = exports.InsightsProvider = void 0;

var _react = require("react");

var _browserHistory = require("../../browserHistory");

var _factory = require("../factory");

var _reducer = require("./reducer");

var _types = require("../../components/Analysis/utils/types");

var _utils = require("../../components/Analysis/utils");

var _constants = require("../../components/Analysis/utils/constants");

var _storage = require("../../utils/storage");

var _useActions = require("./useActions");

const initialState = {
  // Request/Processing State
  isLoading: false,
  isLoaded: false,
  isComposed: false,
  isProcessed: false,
  isFiltered: false,
  // Data State
  rawData: {
    hit: [],
    site: {},
    rule: {},
    priority: {
      0: [],
      1: [],
      2: []
    },
    category: {
      data_uptime: [],
      metering: [],
      optimisation: [],
      fdd: [],
      null: []
    }
  },
  composedFilteredOccurrences: [],
  composedOccurrences: [],
  composedOccurrencesBySite: {},
  composedAndGroupedInsights: [],
  composedAndGroupedOccurrences: [],
  // UI State
  sortDirection: 'desc',
  category: (0, _utils.getCategoryFromQueryString)(_browserHistory.history.location.search),
  groupBy: (0, _storage.getPersisted)({
    prop: _constants.GROUP_BY_KEY,
    key: _constants.INSIGHTS_LS_KEY
  }, _types.GroupBy.Site) || _types.GroupBy.Site,
  sortBy: (0, _storage.getPersisted)({
    prop: _constants.SORT_BY_KEY,
    key: _constants.INSIGHTS_LS_KEY
  }, _types.SortBy.Hits) || _types.SortBy.Hits,
  expandAll: false,
  search: undefined,
  lastActiveRow: undefined
};
const stateContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const dispatchContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const InsightsProvider = (0, _factory.createProvider)(stateContext, dispatchContext, _reducer.reducer, initialState);
exports.InsightsProvider = InsightsProvider;
const useDispatch = (0, _factory.createDispatchHook)(dispatchContext);
exports.useDispatch = useDispatch;
const useState = (0, _factory.createStateHook)(stateContext);
exports.useState = useState;
const useInsights = (0, _factory.createContextHook)(stateContext, dispatchContext);
exports.useInsights = useInsights;